import React from 'react';
import PropTypes from 'prop-types';
import TableBase from './TableBase';

class Table extends React.Component {
  static propTypes = {
    /** Pre-defined custom styles to override TableBase */
    styleType: PropTypes.string,
    /** Classname to be applied to <Table> */
    className: PropTypes.string,
    /** Styles to be applied to component */
    classes: PropTypes.object,
    /** Data that will be used to generate table columns */
    columns: PropTypes.PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string.isRequired,
        displayText: PropTypes.string.isRequired,
        visible: PropTypes.bool,
        sticky: PropTypes.bool,
        sortable: PropTypes.bool,
        renderComponent: PropTypes.function, // allows for custom cell rendering
        customSort: PropTypes.function,
      }),
    ).isRequired,
    /** Data that will be used to generate table rows */
    rows: PropTypes.array.isRequired,
    /** Read Only mode will force table to ignore renderComponent per columns and display cell value */
    readOnly: PropTypes.bool,
    /** Hide header */
    hideHeader: PropTypes.bool,
    /** Page for the table to open at */
    page: PropTypes.number,
    /** Enable/disable table pagination */
    pagination: PropTypes.bool,
    /** Scroll TableScrollbar to top on pagination */
    scrollToTopOnPageChange: PropTypes.bool,
    /** If provided, the total number of rows for the table */
    totalRows: PropTypes.number,
    /** If provided, the total number of rows per page */
    rowsPerPage: PropTypes.number,
    /** Server side mode means that the Table component will not handle pagination/sort. Useful for depedency on API's */
    serverSide: PropTypes.bool,
    /** If provided, the origRowIndex getting reset when sorting NOT handled on Server side i.e when server side mode is OFF*/
    resetDataRowOrigIndexOnClientSideSort: PropTypes.bool,
    /** Populate first column with selectable radio button */
    selectableRows: PropTypes.bool,
    /** Provide custom footer to display with the Table */
    footer: PropTypes.func,
    /** Callback function to get reference to internal setTableModel() method */
    setTableModel: PropTypes.func,
    /** Callback function to get reference to internal updateColumnValue() method */
    updateColumn: PropTypes.func,
    /** Callback function to get reference to internal updateModelValue() method */
    updateModel: PropTypes.func,
    /**
     * Callback function for table updates. fn(actionType: string, tableState: object)
     * tableState enum: ('rowClick', 'cellClick', 'pageChange', 'colSort', 'rowsSelected', 'cellValueUpdate')
     */
    onTableChange: PropTypes.func,
    // Message for when no table data available
    noTableDataMsg: PropTypes.string,
    tableHeadCellProps: PropTypes.object,
    showCheckbox: PropTypes.bool,
    notApplicable: PropTypes.bool,
    notSure: PropTypes.bool,
    parentanyCellSelected: PropTypes.func,
    setCheckboxChecked: PropTypes.func,
    setCheckboxUpdated: PropTypes.func,
    isPageMandatory: PropTypes.bool,
  };

  getStyles = type => {
    switch (type) {
      case 'landingPage':
        return {
          TableBodyCell: {
            rootExtra: {
              cursor: 'pointer',
            },
          },
        };

      case 'dashboard':
        return {
          // TableBodyCell: {
          //   root: {
          //   }
          // }
        };
      case 'landingTaskList': {
        return {
          root: {
            width: '100%',
            height: '100%',
          },
          table: {
            border: 'none',
          },
          TableHeadCell: {
            root: {
              color: '#fff',
            },
          },
        };
      }
      case 'dashboardTaskList': {
        return {
          root: {
            width: '100%',
            height: '302px',
          },
          table: {
            border: 'none',
          },
          TableHeadCell: {
            root: {
              color: '#fff',
            },
          },
        };
      }
      case 'dashboardTaskListQuestionaire': {
        return {
          root: {
            width: '100%',
            height: '465px',
          },
          table: {
            border: 'none',
          },
          TableHeadCell: {
            root: {
              color: '#fff',
            },
          },
        };
      }
      default:
        return {};
    }
  };

  render() {
    const { styleType, parentanyCellSelected, setCheckboxChecked, setCheckboxUpdated, isTaskSubmitted, ...otherProps } = this.props;
    const styles = this.getStyles(styleType);
    //return <TableBase styleOverrides={styles} {...otherProps} />;
    return (
      <TableBase
        styleOverrides={styles}
        setCheckboxChecked={setCheckboxChecked}
        setCheckboxUpdated={setCheckboxUpdated}
        isTaskSubmitted={isTaskSubmitted}
        parentanyCellSelected={this.props.handleparentanyCellSelected}
        {...otherProps}
      />
    );
  }
}

export default Table;
